import Axios from 'axios'
// 跨域时需要在url前加baseURl
import apiConfig from '../../config/api.config'
Axios.defaults.baseURL = apiConfig.baseUrl// 配置接口地址
Axios.defaults.timeout = 180000// 配置接口地址

const CancelToken = Axios.CancelToken
// eslint-disable-next-line
window.abortRequest
// *************************** 发送axios请求 ***************************
const sendAxios = async ({url, type, data, success, error, headers = {}, requestDataType, responseType = 'json', enableAbortRequest = false}) => {
  let sendData = type.toLocaleString() === 'get' ? {params: data} : data
  let transformRequest = []
  // 以form-data的数据格式提交
  if (requestDataType === 'form-data') {
    headers = {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    }
    transformRequest = [
      function (data) {
        let ret = ''
        for (let it in data) {
          if(data[it] == undefined){
            continue
          }
          ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
        }
        ret = ret.substring(0, ret.lastIndexOf('&'))
        return ret
      }
    ]
  }
  if (responseType === 'document') {
    headers = {
      // Accept: '*/*'
    }
  }
  // 终止请求
  let abortFunc = null
  if (enableAbortRequest) {
    abortFunc = new CancelToken(function executor (c) {
      window.abortRequest = c
    })
  }
  let successCallBack = resp => {
    success(resp)
  }
  let errorCallBack = err => {
    if (error) {
      error(err)
    } else {
      // this.$Message.error(err)
      console.log('请求错误:' + url)
      console.log(err)
    }
  }
  if (requestDataType === 'form-data') {
    if (url === '/map/districtInfo') {
      console.log(responseType)
    }
    await Axios[type](url, sendData, {headers: headers, transformRequest: transformRequest, cancelToken: abortFunc, responseType: responseType})
      .then(successCallBack)
      .catch(errorCallBack)
  } else {
    if (url === '/map/districtInfo') {
      console.log(responseType)
    }
    await Axios[type](url, sendData, {headers: headers, cancelToken: abortFunc, responseType: responseType})
      .then(successCallBack)
      .catch(errorCallBack)
  }
}

const checkPermission = ({type = 'get', data = {}, success, error}) => {
  sendAxios({
    url: '/projectinfo/checkPermission',
    type: type,
    data: data,
    success: success,
    error: error
  })
}

// *************************** 获取昨日运行情况的完成任务、日常计划 ***************************
const getTemplateAndPlanCount = ({type = 'post', data = {}, success, error}) => {
  sendAxios({
    url: '/projectinfo/getTemplateAndPlanCount',
    type: type,
    data: data,
    success: success,
    error: error
  })
}
// *************************** 获取水量信息； 进水量 出水量 负荷率 ***************************
const waterYieldInfo = ({type = 'post', data = {}, success, error}) => {
  sendAxios({
    url: '/projectinfo/waterYieldInfo',
    type: type,
    data: data,
    success: success,
    error: error
  })
}
// *************************** 获取水量峰值信息, 进水峰值 进水谷值 ***************************
const waterYieldPeakInfo = ({type = 'post', data = {}, success, error}) => {
  sendAxios({
    url: '/projectinfo/waterYieldPeakInfo',
    type: type,
    data: data,
    success: success,
    error: error
  })
}
// *************************** 获取出水水质各指标的平均值 ***************************
const waterQualityInfo = ({type = 'post', data = {}, success, error}) => {
  sendAxios({
    url: '/projectinfo/waterQualityInfo',
    type: type,
    data: data,
    success: success,
    error: error
  })
}
// *************************** 获取水质达标率信息, 达标率,达标天数 ***************************
const waterQualityStandardInfo = ({type = 'post', data = {}, success, error}) => {
  sendAxios({
    url: '/projectinfo/waterQualityStandardInfo',
    type: type,
    data: data,
    success: success,
    error: error
  })
}
// *************************** 获取水质趋势 ***************************
const getTrendData = ({type = 'post', data = {}, success, error, requestDataType = '', enableAbortRequest = false}) => {
  sendAxios({
    url: '/waterQuality/getTrendData',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}
// *************************** 设备异常信息（人工上报事件）,设备台数 异常个数 维修次数 异常设备列表 ***************************
const equAbnormityInfo = ({type = 'post', data = {}, success, error}) => {
  sendAxios({
    url: '/projectinfo/equAbnormityInfo',
    type: type,
    data: data,
    success: success,
    error: error
  })
}
// *************************** 获取保养计划信息（最小粒度是月，按月统计）, 计划保养次数 已保养次数 未保养次数 ***************************
const equMaintainPlanInfo = ({type = 'post', data = {}, success, error}) => {
  sendAxios({
    url: '/projectinfo/equMaintainPlanInfo',
    type: type,
    data: data,
    success: success,
    error: error
  })
}
// *************************** 获取保养记录信息, 保养次数 保养设备台数 ***************************
const equMaintainRecordInfo = ({type = 'post', data = {}, success, error}) => {
  sendAxios({
    url: '/projectinfo/equMaintainRecordInfo',
    type: type,
    data: data,
    success: success,
    error: error
  })
}
// *************************** 获取加药信息, PAC消耗 PAM消耗 次钠消耗 吨水PAC PAM投配率 吨水次钠 ***************************
const medicamentInfo = ({type = 'post', data = {}, success, error}) => {
  sendAxios({
    url: '/projectinfo/medicamentInfo',
    type: type,
    data: data,
    success: success,
    error: error
  })
}
// *************************** 获取排泥信息； 排泥总量 干泥总量 排泥次数 吨水排泥 ***************************
const mudInfo = ({type = 'post', data = {}, success, error}) => {
  sendAxios({
    url: '/projectinfo/mudInfo',
    type: type,
    data: data,
    success: success,
    error: error
  })
}
// *************************** 获取成本信息； 耗电量 吨水电耗 ***************************
const costInfo = ({type = 'post', data = {}, success, error}) => {
  sendAxios({
    url: '/projectinfo/costInfo',
    type: type,
    data: data,
    success: success,
    error: error
  })
}
// *************************** 获取水量信息； 进水量 出水量 负荷率的实时信息 ***************************
const waterYieldInfoCur = ({type = 'post', data = {}, success, error}) => {
  sendAxios({
    url: '/projectinfo/waterYieldInfoCur',
    type: type,
    data: data,
    success: success,
    error: error
  })
}
// *************************** 获取水质进出水口的实时信息 ***************************
const qualityRealTimeInfo = ({type = 'post', data = {}, success, error}) => {
  sendAxios({
    url: '/projectinfo/qualityRealTimeInfo',
    type: type,
    data: data,
    success: success,
    error: error
  })
}
// *************************** 获取进出水口的瞬时水量实时信息 ***************************
const yieldRealTimeInfo = ({type = 'get', data = {}, success, error}) => {
  sendAxios({
    url: '/projectinfo/yieldRealTimeInfo',
    type: type,
    data: data,
    success: success,
    error: error
  })
}
// *************************** 获取设备状态统计的实时信息 ***************************
const equRealTimeInfo = ({type = 'get', data = {}, success, error}) => {
  sendAxios({
    url: '/projectinfo/equRealTimeInfo',
    type: type,
    data: data,
    success: success,
    error: error
  })
}
// *************************** 获取故障维修的列表信息 ***************************
const newestAbnormityRecordList = ({type = 'post', data = {}, success, error}) => {
  sendAxios({
    url: '/projectinfo/newestAbnormityRecordList',
    type: type,
    data: data,
    success: success,
    error: error
  })
}
// *************************** 判断记录是否存在并跳转 ***************************
const checkIfExist = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/abnormityRecord/checkIfExist',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}

// *************************** 获取今日完成的任务，未完成的任务，任务列表 ***************************
const temporaryPlanToday = ({type = 'post', data = {}, success, error}) => {
  sendAxios({
    url: '/projectinfo/temporaryPlanToday',
    type: type,
    data: data,
    success: success,
    error: error
  })
}
// *************************** 计划完成进度 ***************************
const planSpeedOfProgressTop = ({type = 'post', data = {}, success, error}) => {
  sendAxios({
    url: '/projectinfo/planSpeedOfProgressTop',
    type: type,
    data: data,
    success: success,
    error: error
  })
}
// *************************** 获取全年的计划完成进度信息 ***************************
const planSpeedOfProgressBody = ({type = 'post', data = {}, success, error}) => {
  sendAxios({
    url: '/projectinfo/planSpeedOfProgressBody',
    type: type,
    data: data,
    success: success,
    error: error
  })
}
// *************************** 获取全年的计划完成进度信息 ***************************
const planInfo = ({type = 'post', data = {}, success, error}) => {
  sendAxios({
    url: '/projectinfo/planInfo',
    type: type,
    data: data,
    success: success,
    error: error
  })
}
// *************************** 获取进水/出水水量图表的数据;（柱状图、折线图） ***************************
const waterInletTrendChart = ({type = 'post', data = {}, success, error, requestDataType = '', enableAbortRequest = false}) => {
  sendAxios({
    url: '/waterYield/waterInletTrendChart',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}
// *************************** 获取进水/获取水质的图表数据 ***************************
const getOutWaterQualityTrendData = ({type = 'post', data = {}, success, error}) => {
  sendAxios({
    url: '/waterQuality/getOutWaterQualityTrendData',
    type: type,
    data: data,
    success: success,
    error: error
  })
}

/// //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// *************************** 根据登录的地址获取公司对应的页面展示信息 ***************************
const queryCorpByParam = ({type = 'post', data = {}, success, error}) => {
  sendAxios({
    url: '/corp/queryCorpByParam',
    type: type,
    data: data,
    success: success,
    error: error
  })
}
// *************************** 更新公司信息 ***************************
const updateCorp = ({type = 'post', data = {}, success, error}) => {
  sendAxios({
    url: '/corp/updateCorp',
    type: type,
    data: data,
    success: success,
    error: error
  })
}
// *************************** 直接获取公司信息 ***************************
const queryCurUserCorp = ({type = 'post', data = {}, success, error}) => {
  sendAxios({
    url: '/corp/queryCurUserCorp',
    type: type,
    data: data,
    success: success,
    error: error
  })
}
// *************************** 注册界面验证验证码 ***************************
const captchaCheck = ({type = 'post', data = {}, success, error}) => {
  sendAxios({
    url: '/register/captchaCheck',
    type: type,
    data: data,
    success: success,
    error: error
  })
}
// *************************** 注册界面验证用户名 ***************************
const checkName = ({type = 'post', data = {}, success, error}) => {
  sendAxios({
    url: '/register/checkName',
    type: type,
    data: data,
    success: success,
    error: error
  })
}
// *************************** 注册用户 ***************************
const registerProjectUser = ({type = 'post', data = {}, success, error}) => {
  sendAxios({
    url: '/register/registerProjectUser',
    type: type,
    data: data,
    success: success,
    error: error
  })
}
// *************************** 忘记密码修改 ***************************
const forgetPassword = ({type = 'post', data = {}, success, error}) => {
  sendAxios({
    url: '/modify/forgetPassword' + data,
    type: type,
    success: success,
    error: error
  })
}
// *************************** 修改用户密码 ***************************
const modifyPassword = ({type = 'get', data = {}, success, error}) => {
  sendAxios({
    url: '/modify/modifyPassword',
    type: type,
    data: data,
    success: success,
    error: error
  })
}
// *************************** 用户名登录 ***************************
const login = ({type = 'post', data = {}, success, error}) => {
  sendAxios({
    url: '/login',
    type: type,
    data: data,
    success: success,
    error: error
  })
}
// *************************** 短信登录 ***************************
const mobileLogin = ({type = 'post', data = {}, success, error}) => {
  sendAxios({
    url: '/register/mobileLogin',
    type: type,
    data: data,
    success: success,
    error: error
  })
}
// *************************** 发送短信验证码 ***************************
const sendSms = ({type = 'post', data = {}, success, error}) => {
  sendAxios({
    url: '/register/sendSms',
    type: type,
    data: data,
    success: success,
    error: error
  })
}
// *************************** 验证账号是否绑定手机 ***************************
const checkIfBindMobile = ({type = 'post', data = {}, success, error}) => {
  sendAxios({
    url: '/register/checkIfBindMobile',
    type: type,
    data: data,
    success: success,
    error: error
  })
}
// *************************** 短信登录，验证手机号 ***************************
const checkMobile = ({type = 'post', data = {}, success, error}) => {
  sendAxios({
    url: '/register/checkMobile',
    type: type,
    data: data,
    success: success,
    error: error
  })
}
// *************************** 短信验证码确认 ***************************
const checkVerifyCodeCache = ({type = 'post', data = {}, success, error}) => {
  sendAxios({
    url: '/register/checkVerifyCodeCache',
    type: type,
    data: data,
    success: success,
    error: error
  })
}
// *************************** 注册时验证手机号 ***************************
const checkUserMobile = ({type = 'post', data = {}, success, error}) => {
  sendAxios({
    url: '/register/checkUserMobile',
    type: type,
    data: data,
    success: success,
    error: error
  })
}
// *********************二维码登录***************
const QRCodeLogin = ({type = 'post', data = {}, success, error}) => {
  sendAxios({
    url: '/login/QRCodeLogin',
    type: type,
    data: data,
    success: success,
    error: error
  })
}

/// //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// *********************新增摄像头***************
const saveCamera = ({type = 'post', data = {}, success, error}) => {
  sendAxios({
    url: '/camera/saveCamera',
    type: type,
    data: data,
    success: success,
    error: error
  })
}
// *********************删除摄像头***************
const deleteCamera = ({type = 'post', data = {}, success, error}) => {
  sendAxios({
    url: '/camera/deleteCamera',
    type: type,
    data: data,
    success: success,
    error: error
  })
}
// *********************修改摄像头***************
const updateCameraById = ({type = 'post', data = {}, success, error}) => {
  sendAxios({
    url: '/camera/updateCameraById',
    type: type,
    data: data,
    success: success,
    error: error
  })
}
// *********************根据条件查询摄像头列表***************
const queryCameraByParam = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/camera/queryCameraByParam',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// *********************根据序列号和通道号条件查询摄像头列表***************
const checkDuplicateCameraByParam = async ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  let obj = {
    url: '/camera/checkDuplicateCameraByParam',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  }
  if (async) {
    sendAxios(obj)
  } else {
    await sendAxios(obj)
  }
}
// *********************根据id查询摄像头***************
const queryCameraById = ({type = 'post', data = {}, success, error}) => {
  sendAxios({
    url: '/camera/queryCameraById',
    type: type,
    data: data,
    success: success,
    error: error
  })
}
// *********************新增预置点***************
const saveCameraPreset = ({type = 'post', data = {}, success, error}) => {
  sendAxios({
    url: '/camera/saveCameraPreset',
    type: type,
    data: data,
    success: success,
    error: error
  })
}
// *********************删除预置点***************
const deleteCameraPreset = ({type = 'post', data = {}, success, error}) => {
  sendAxios({
    url: '/camera/deleteCameraPreset',
    type: type,
    data: data,
    success: success,
    error: error
  })
}
// *********************修改预置点***************
const updateCameraPresetById = ({type = 'post', data = {}, success, error}) => {
  sendAxios({
    url: '/camera/updateCameraPresetById',
    type: type,
    data: data,
    success: success,
    error: error
  })
}
// *********************根据条件查询预置点列表(名称重复验证)***************
const queryCameraPresetByParam = ({type = 'post', data = {}, success, error}) => {
  sendAxios({
    url: '/camera/queryCameraPresetByParam',
    type: type,
    data: data,
    success: success,
    error: error
  })
}
// *********************根据id查询预置点***************
const queryCameraPresetById = ({type = 'post', data = {}, success, error}) => {
  sendAxios({
    url: '/camera/queryCameraPresetById',
    type: type,
    data: data,
    success: success,
    error: error
  })
}

// *********************新增账户***************
const saveCameraAccount = ({type = 'post', data = {}, success, error}) => {
  sendAxios({
    url: '/camera/saveCameraAccount',
    type: type,
    data: data,
    success: success,
    error: error
  })
}
// *********************删除账户***************
const deleteCameraAccount = ({type = 'post', data = {}, success, error}) => {
  sendAxios({
    url: '/camera/deleteCameraAccount',
    type: type,
    data: data,
    success: success,
    error: error
  })
}
// *********************修改账户***************
const updateCameraAccountById = ({type = 'post', data = {}, success, error}) => {
  sendAxios({
    url: '/camera/updateCameraAccountById',
    type: type,
    data: data,
    success: success,
    error: error
  })
}
// *********************根据条件查询账户列表***************
const queryCameraAccountByParam = ({type = 'post', data = {}, success, error}) => {
  sendAxios({
    url: '/camera/queryCameraAccountByParam',
    type: type,
    data: data,
    success: success,
    error: error
  })
}
// *********************根据条件查询乐橙云序列号是否有效***************
const deviceOnline = ({type = 'post', data = {}, success, error}) => {
  sendAxios({
    url: '/Contorl/deviceOnline',
    type: type,
    data: data,
    success: success,
    error: error
  })
}
// *********************根据id查询账户***************
const queryCameraAccountById = ({type = 'post', data = {}, success, error}) => {
  sendAxios({
    url: '/camera/queryCameraAccountById',
    type: type,
    data: data,
    success: success,
    error: error
  })
}

// *********************图片任务列表查看***************
const queryCameraPicTaskList = ({type = 'post', data = {}, success, error}) => {
  sendAxios({
    url: '/camera/queryCameraPicTaskList',
    type: type,
    data: data,
    success: success,
    error: error
  })
}
// *********************记录摄像头和图片查看***************
const queryCameraAndPicList = ({type = 'post', data = {}, success, error}) => {
  sendAxios({
    url: '/camera/queryCameraAndPicList',
    type: type,
    data: data,
    success: success,
    error: error
  })
}
// *********************任务列表***************
const queryCameraTaskByParam = ({type = 'post', data = {}, success, error}) => {
  sendAxios({
    url: '/camera/queryCameraTaskByParam',
    type: type,
    data: data,
    success: success,
    error: error
  })
}
// *********************任务新增***************
const saveCameraTask = ({type = 'post', data = {}, success, error}) => {
  sendAxios({
    url: '/camera/saveCameraTask',
    type: type,
    data: data,
    success: success,
    error: error
  })
}
// *********************任务删除***************
const deleteCameraTask = ({type = 'post', data = {}, success, error}) => {
  sendAxios({
    url: '/camera/deleteCameraTask',
    type: type,
    data: data,
    success: success,
    error: error
  })
}
// *********************根据任务id查询摄像头和预置点列表***************
const queryCameraAndPresetByParam = ({type = 'post', data = {}, success, error}) => {
  sendAxios({
    url: '/camera/queryCameraAndPresetByParam',
    type: type,
    data: data,
    success: success,
    error: error
  })
}
// *********************任务修改***************
const updateCameraTaskById = ({type = 'post', data = {}, success, error}) => {
  sendAxios({
    url: '/camera/updateCameraTaskById',
    type: type,
    data: data,
    success: success,
    error: error
  })
}
// *********************批量保存抓拍定时任务绑定的预置点***************
const saveCameraTaskDetailBatch = ({type = 'post', data = {}, success, error}) => {
  sendAxios({
    url: '/camera/saveCameraTaskDetailBatch',
    type: type,
    data: data,
    success: success,
    error: error
  })
}
// *********************修改抓拍定时任务绑定的预置点***************
const updateCameraTaskDetail = ({type = 'post', data = {}, success, error}) => {
  sendAxios({
    url: '/camera/updateCameraTaskDetail',
    type: type,
    data: data,
    success: success,
    error: error
  })
}
// *********************根据id查询任务***************
const queryCameraTaskById = ({type = 'post', data = {}, success, error}) => {
  sendAxios({
    url: '/camera/queryCameraTaskById',
    type: type,
    data: data,
    success: success,
    error: error
  })
}
// *********************新增和修改任务详情初始化（更新任务预置点初始化数据）***************
const queryPresetListByParam = ({type = 'post', data = {}, success, error}) => {
  sendAxios({
    url: '/camera/queryPresetListByParam',
    type: type,
    data: data,
    success: success,
    error: error
  })
}
// *********************查询人员列表***************
const userList = ({type = 'post', data = {}, success, error}) => {
  sendAxios({
    url: '/user/userList',
    type: type,
    data: data,
    success: success,
    error: error
  })
}

// *****************************************************************摄像头直播相关*****************************************************************
// *********************得到萤石云token***************
const getEZVIZToken = ({type = 'post', data = {}, success, error, headers, requestDataType = ''}) => {
  sendAxios({
    url: '/Contorl/getEZVIZToken',
    type: type,
    data: data,
    success: success,
    error: error,
    headers: headers,
    requestDataType: requestDataType
  })
}
// *********************根据项目ID得到摄像头列表***************
const getCameralist = ({type = 'post', data = {}, success, error, headers, requestDataType = '', enableAbortRequest = false}) => {
  sendAxios({
    url: '/Contorl/getCameralist',
    type: type,
    data: data,
    success: success,
    error: error,
    headers: headers,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}
// *********************根据项目ID得到摄像头列表以及预置点列表***************
const getCameralistAndPreset = ({type = 'post', data = {}, success, error, headers, requestDataType = '', enableAbortRequest = false}) => {
  sendAxios({
    url: '/Contorl/getCameralistAndPreset',
    type: type,
    data: data,
    success: success,
    error: error,
    headers: headers,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}
// *********************根据项目ID得到摄像头列表（根据位置分类）***************
const getAllCameraGroupByPosition = ({type = 'post', data = {}, success, error, headers, requestDataType = '', enableAbortRequest = false}) => {
  sendAxios({
    url: '/camera/getAllCameraGroupByPosition',
    type: type,
    data: data,
    success: success,
    error: error,
    headers: headers,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}
// *********************根据摄像头ID得到详细信息***************
const getCameraInfo = ({type = 'post', data = {}, success, error, headers, requestDataType = ''}) => {
  sendAxios({
    url: '/Contorl/getCameraInfo',
    type: type,
    data: data,
    success: success,
    error: error,
    headers: headers,
    requestDataType: requestDataType
  })
}
// *********************得到萤石云的摄像头信息***************
const getEZVIZCameraInfo = ({type = 'get', data = {}, success, error, headers, requestDataType = ''}) => {
  sendAxios({
    url: '/Contorl/getEZVIZCameraInfo',
    type: type,
    data: data,
    success: success,
    error: error,
    headers: headers,
    requestDataType: requestDataType
  })
}
// *********************摄像头-云台控制***************
const ptzControl = ({type = 'get', data = {}, success, error, headers, requestDataType = ''}) => {
  sendAxios({
    url: '/Contorl/ptzControl',
    type: type,
    data: data,
    success: success,
    error: error,
    headers: headers,
    requestDataType: requestDataType
  })
}
// *********************乐橙摄像头-云台控制***************
const consoleControl = ({type = 'get', data = {}, success, error, headers, requestDataType = ''}) => {
  sendAxios({
    url: '/Contorl/consoleControl',
    type: type,
    data: data,
    success: success,
    error: error,
    headers: headers,
    requestDataType: requestDataType
  })
}
// *********************摄像头-添加预置点***************
const presetEZVIZAdd = ({type = 'get', data = {}, success, error, headers, requestDataType = ''}) => {
  sendAxios({
    url: '/Contorl/presetEZVIZAdd',
    type: type,
    data: data,
    success: success,
    error: error,
    headers: headers,
    requestDataType: requestDataType
  })
}
// *********************调用预置点***************
const presetMove = ({type = 'post', data = {}, success, error, headers, requestDataType = ''}) => {
  sendAxios({
    url: '/Contorl/presetMove',
    type: type,
    data: data,
    success: success,
    error: error,
    headers: headers,
    requestDataType: requestDataType
  })
}
// *********************清除预置点***************
const presetEZVIZClear = ({type = 'post', data = {}, success, error, headers, requestDataType = ''}) => {
  sendAxios({
    url: '/Contorl/presetEZVIZClear',
    type: type,
    data: data,
    success: success,
    error: error,
    headers: headers,
    requestDataType: requestDataType
  })
}
// *********************根据摄像头id 时间段 抓拍类型 获取图片列表，项目id***************
const getCameraPicforCameraId = ({type = 'post', data = {}, success, error, headers, requestDataType = ''}) => {
  sendAxios({
    url: '/Contorl/getCameraPicforCameraId',
    type: type,
    data: data,
    success: success,
    error: error,
    headers: headers,
    requestDataType: requestDataType
  })
}
// *********************删除图片***************
const delCameraPic = ({type = 'post', data = {}, success, error, headers, requestDataType = ''}) => {
  sendAxios({
    url: '/Contorl/delCameraPic',
    type: type,
    data: data,
    success: success,
    error: error,
    headers: headers,
    requestDataType: requestDataType
  })
}
// *********************删除多张图片***************
const delMultiCameraPic = ({type = 'get', data = {}, success, error, headers, requestDataType = ''}) => {
  sendAxios({
    url: '/Contorl/delMultiCameraPic',
    type: type,
    data: data,
    success: success,
    error: error,
    headers: headers,
    requestDataType: requestDataType
  })
}
// *********************抓拍***************
const capturePic = ({type = 'post', data = {}, success, error, headers, requestDataType = ''}) => {
  sendAxios({
    url: '/Contorl/capturePic',
    type: type,
    data: data,
    success: success,
    error: error,
    headers: headers,
    requestDataType: requestDataType
  })
}
// *********************演进***************
const gradualProgress = ({type = 'post', data = {}, success, error, headers, requestDataType = ''}) => {
  sendAxios({
    url: '/Contorl/gradualProgress',
    type: type,
    data: data,
    success: success,
    error: error,
    headers: headers,
    requestDataType: requestDataType
  })
}
// *********************获取摄像头位置列表***************
const getCameraPosition = ({type = 'post', data = {}, success, error, headers, requestDataType = ''}) => {
  sendAxios({
    url: '/camera/getCameraPosition',
    type: type,
    data: data,
    success: success,
    error: error,
    headers: headers,
    requestDataType: requestDataType
  })
}
// *********************得到乐橙云token***************
const getKitToken = ({type = 'post', data = {}, success, error, headers, requestDataType = ''}) => {
  sendAxios({
    url: '/Contorl/getKitToken',
    type: type,
    data: data,
    success: success,
    error: error,
    headers: headers,
    requestDataType: requestDataType
  })
}

// *****************************************************************微信公众号*****************************************************************
// *********************获取任务详情***************
const WxProjectInfo = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/wechat/projectInfo',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// *********************根据code和appid获取openId***************
const WxGetOpenId = ({type = 'post', data = {}, success, error}) => {
  sendAxios({
    url: '/wechat/getOpenId',
    type: type,
    data: data,
    success: success,
    error: error
  })
}
// *********************绑定手机号***************
const WxBindWechatMobile = ({type = 'post', data = {}, success, error}) => {
  sendAxios({
    url: '/register/bindWechatMobile',
    type: type,
    data: data,
    success: success,
    error: error
  })
}
// *********************绑定账号***************
const WxRelateUser = ({type = 'post', data = {}, success, error}) => {
  sendAxios({
    url: '/wechat/relateUser',
    type: type,
    data: data,
    success: success,
    error: error
  })
}

// *****************************************************************bim界面*****************************************************************
// *********************获取bim的viewToken和fileId***************
const getViewToken = ({type = 'post', data = {}, success, error, requestDataType = '', enableAbortRequest = false}) => {
  sendAxios({
    url: '/bim/getViewToken',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}
// *********************通过项目id获取下面的工艺单元列表、设备列表、监测点列表(仅用于获取bim构件信息工具中使用)***************
const getEquMstMonitorList = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/equipmentMgt/getEquMstMonitorList',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// *********************保存获取的bim构件信息(仅用于获取bim构件信息工具中使用)***************
const save3dPoint = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/bim/save3dPoint',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}

// *********************解除bim组件绑定***************
const cancleBind = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/bim/cancleBind',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}

// *********************设置bim的默认视角(仅用于获取bim构件信息工具中使用)***************
const saveBimDefCameraStatus = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/bim/saveBimDefCameraStatus',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// *********************保存bim的gis配置项(仅用于获取bim构件信息工具中使用)***************
const saveBimGisPoints = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/bim/saveBimGisPoints',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// *********************获取巡检计划列表(仅用于获取bim构件信息工具中使用)***************
const getBimInspectPlan = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/bim/getBimInspectPlan',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// *********************根据巡检计划获取巡检点列表(仅用于获取bim构件信息工具中使用)***************
const getBimInspectPointByPlanId = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/bim/getBimInspectPointByPlanId',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// *********************保存单个巡检点视角定位(仅用于获取bim构件信息工具中使用)***************
const saveInspectPointBimInfo = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/bim/saveInspectPointBimInfo',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// *********************保存漫游点(仅用于获取bim构件信息工具中使用)***************
const saveRoamingPoint = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/bim/saveRoamingPoint',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// *********************获取漫游点名称列表(仅用于获取bim构件信息工具中使用)***************
const getRoamingPointNameList = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/bim/getRoamingPointNameList',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// *********************根据漫游路径id获取所有漫游点表(仅用于获取bim构件信息工具中使用)***************
const getRoamingPointListByRoamingPointId = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/bim/getRoamingPointListByRoamingPointId',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// *********************获取巡检点目录树(仅用于获取bim构件信息工具中使用)***************
const getInspectPlanBimTree = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/bim/getInspectPlanBimTree',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// *********************删除某条漫游路径(仅用于获取bim构件信息工具中使用)***************
const deleteRoaming = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/bim/deleteRoaming',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}

// *********************获取构件树***************
const getEleMenu = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/bim/getEleMenu',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// *********************获取模型的构件与设备对应关系***************
const listEquElementRelation = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/model/listEquElementRelation',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// *********************获取模型水厂综合汇总信息***************
const showInfo = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/module/showInfo',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// *********************获取模型水厂综合汇总信息***************
const getCockpitSumData = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/Analyse/getCockpitSumData',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 获取某个设备下的监测点列表（只渲染监测点列表和状态，不渲染状态的值）***************
const getEquMonitor = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/fcx/getEquMonitor',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 根据监测点id获取监测点的所有状态 ***************
const getEquipValue = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/model/getEquipValue',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 获取设备故障维修记录列表 ***************
const abnormityRecordListData = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/abnormityRecord/abnormityRecordListData',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 获取故障维修分析数据 ***************
const abnormityRecordListByDate = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/abnormityRecord/abnormityRecordListByDate',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 获取监测点列表数据 ***************
const getMonitorDate = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/monitor/getMonitorDate',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 获取监测点的数量,包含摄像头和设备 ***************
const getAllMonitorCount = ({type = 'get', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/monitor/getAllMonitorCount',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 获取监测点在线离线数量 ***************
const getMonitorOffLineCount = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/monitor/getMonitorOffLineCount',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 获取设备故障消息列表 ***************
const getMsgInfo = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/bim/getMsgInfo',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 获取收集的bim上的设备三维坐标信息（自己用） ***************
const getCollectBimEquInfo = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/bim/getCollectBimEquInfo',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 获取bim工艺单元及设备标签点数据(综合信息下的,包括自动故障设备+预警工艺单元) ***************
const getProjectMstBreakList = async ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  let obj = {
    url: '/bim/getProjectMstBreakList',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  }
  if (async) {
    sendAxios(obj)
  } else {
    await sendAxios(obj)
  }
}
// ********************* 获取bim工艺单元及设备标签点数据(设备维修下的，包括除了已完成为维修的设备+预警工艺单元) ***************
const getProjectMstBreakListManual = async ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  let obj = {
    url: '/bim/getProjectMstBreakListManual',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  }
  if (async) {
    sendAxios(obj)
  } else {
    await sendAxios(obj)
  }
}
// ********************* 获取bim工艺单元及设备标签点数据（设备保养下的,，除了已完成保养的设备的数量） ***************
const getMaintainEquipOfAreaList = async ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  let obj = {
    url: '/bim/getMaintainEquipOfAreaList',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  }
  if (async) {
    sendAxios(obj)
  } else {
    await sendAxios(obj)
  }
}

// ********************* 获取设备保养记录列表 ***************
const maintenanceRecordListData = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/equipmentMgt/maintenanceRecord/list',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 获取设备保养记录列表 ***************
const maintenanceRecordPlanCount = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/equipmentMgt/maintenanceRecord/planCount',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}

// ********************* 获取故障时长排行 ***************
const breakdownTimeRank = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/breakdown/management/datanews',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 故障排行 ***************
const datanewRankList = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/breakdown/management/datanewRankList',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 设备故障统计 ***************
const datanewEquBreakdown = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/breakdown/management/datanewEquBreakdown',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 故障趋势分析 ***************
const datanewBreakdown = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/breakdown/management/datanewBreakdown',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 获取故障设备分析 ***************
const getEquBreakdown = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/breakdown/getEquBreakdown',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 获取设备基本信息 ***************
const getEquInfoByEquId = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/model/getEquInfoByEquId',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 获取设备基本信息 ***************
const getAbnormityRate = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/breakdown/getAbnormityRate',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 获取设备运行信息 ***************
const getAnalyseDataforProject = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/Analyse/getAnalyseDataforProject',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 获取设备运行分析-时长-次数 ***************
const getRunTimeAnalyse = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/Analyse/getRunTimeAnalyse',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}

// *****************************************************************bim模块（水厂版多模块界面）*****************************************************************
// ********************* 获取工艺单元下所有设备 ***************
const bimGetAllEquByUnitId = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/bim/getAllEquByUnitId',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 获取工艺单元下的预警 ***************
const bimGetEquWaringList = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/bim/getEquWaringList',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 获取设备基本信息 ***************
const bimGetEquInfoById = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/bim/getEquInfoById',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 获取设备维护数量 ***************
const bimGetEquMaintainInfo = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/bim/getEquMaintainInfo',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 获取设备维护数量 ***************
const bimEquTimeInfo = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/bim/equTimeInfo',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 查询水量负荷率 瞬时累计进水量和出水量的接口 ***************
const getYieldSomeInfo = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/projectinfo/getYieldSomeInfo',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 获取预警总数/水量预警/水质预警/设备预警/液位预警 ***************
const getWarningLevelData = ({type = 'get', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/warning/getWarningLevelData',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 获取项目下gis标签和预警状态 ***************
const bimGetGisTitleList = ({type = 'post', data = {}, success, error, requestDataType = '', enableAbortRequest = false}) => {
  sendAxios({
    url: '/bim/getGisTitleList',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}
// ********************* 获取项目下gis实时监测标签和预警状态 ***************
const bimGetGisTitlegetMonitorPointList = ({type = 'post', data = {}, success, error, requestDataType = '', enableAbortRequest = false}) => {
  sendAxios({
    url: '/bim/getGisTitlegetMonitorPointList',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}
// ********************* 获取液位监测点液位状态分析 ***************
const getFluidLevelChartData = ({type = 'get', data = {}, success, error, requestDataType = '', enableAbortRequest = false}) => {
  sendAxios({
    url: '/monitor/getFluidLevelChartData',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}
// ********************* 获取液位监测点液位状态分析 ***************
const getFluidChartData = ({type = 'get', data = {}, success, error, requestDataType = '', enableAbortRequest = false}) => {
  sendAxios({
    url: '/monitor/getFluidChartData',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}
// ********************* 根据工艺单元查询工艺单元下所有设备实时信息 ***************
const bimGetAreaEquInfoByAreaId = ({type = 'post', data = {}, success, error, requestDataType = '', enableAbortRequest = false}) => {
  sendAxios({
    url: '/bim/getAreaEquInfoByAreaId',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}
// ********************* 根据预警类型获取预警信息/预警类型:0、水质，1、水量、2、设备，3、液位 ***************
const getWarningTypeData = ({type = 'post', data = {}, success, error, requestDataType = '', enableAbortRequest = false}) => {
  sendAxios({
    url: '/warning/warningType/data',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}
// ********************* 获取监测点 ***************
const getMonitorListWeb = ({type = 'post', data = {}, success, error, requestDataType = '', enableAbortRequest = false}) => {
  sendAxios({
    url: '/monitor/areaGroup/getMonitorList',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}
// ********************* 获取监测点-累计水量-瞬时水量 ***************
const waterYieldInstantaddupValue = ({type = 'get', data = {}, success, error, requestDataType = '', enableAbortRequest = false}) => {
  sendAxios({
    url: '/waterYield/instantaddup/value',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}
// ********************* 获取设备-运行设备按照工艺段/工艺单元分布 ***************
const getModelAreaRunCount = ({type = 'get', data = {}, success, error, requestDataType = '', enableAbortRequest = false}) => {
  sendAxios({
    url: '/model/area/run/count',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}
// ********************* 获取设备-故障设备按照工艺段/工艺单元分布 ***************
const getModelAreaBreakCount = ({type = 'get', data = {}, success, error, requestDataType = '', enableAbortRequest = false}) => {
  sendAxios({
    url: '/model/area/break/count',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}
// ********************* 获取bim模型构建的code ***************
const bimGetElementAttr = ({type = 'get', data = {}, success, error, requestDataType = '', enableAbortRequest = false}) => {
  sendAxios({
    url: '/bim/getElementAttr',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}
// ********************* 获取bim模型管线的配置信息 ***************
const bimGetPipelineConfigDatas = async ({type = 'get', data = {}, success, error, requestDataType = '', enableAbortRequest = false, async = true}) => {
  let obj = {
    url: '/bim/getPipelineConfigDatas',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  }
  if (async) {
    sendAxios(obj)
  } else {
    await sendAxios(obj)
  }
}
// ********************* 获取设备是否有保养计划 ***************
const queryPlanListByEquipId = ({type = 'get', data = {}, success, error, requestDataType = '', enableAbortRequest = false}) => {
  sendAxios({
    url: '/maintenance/queryPlanListByEquipId',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}

// *****************************************************************河道单项目界面*****************************************************************
// ********************* 单项目gis获取侧边导航菜单 ***************
const getMenuTree = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/role/getMenuTree',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 获取天气 ***************
const getCityWeather = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: 'https://www.tianqiapi.com/api/',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 获取项目总览数据 ***************
const getRiverRealTimeWq = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/fcx/getRiverRealTimeWq',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 获取河道运维统计数据 ***************
const getRiverSum = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/fcx/getRiverSum',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 预警和故障信息接口 ***************
const warningList = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/fcx/warningList',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 更新后端项目id ***************
const updateProject = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/project/updateProject',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 获取任务清单 ***************
const planInfoList = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/fcx/planInfoList',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 获取设备列表数据 ***************
const equlist = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/fcx/equlist',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 切换工艺单元的运行模式 ***************
const updateRunMode = ({type = 'get', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/technology/update/runMode',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 获取设备的运行状态 ***************
const getEquStatus = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/fcx/getEquStatus',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 获取远程控制运行时长 ***************
const getEquSummary = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/equipment/getEquSummary',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 获取plc列表 ***************
const getControlListforMonitorId = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/monitor/getControlListforMonitorId',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 获取远程控制信息 ***************
const getControlInfo = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/monitor/getControlInfo',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 发送控制指令 ***************
const controlExecute = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/monitor/control/execute',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 刷新执行状态 ***************
const executeStatus = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/monitor/control/executeStatus',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 远程控制验证密码 ***************
const checkPwd = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/fcx/checkPwd',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 获取某个设备的基本信息 ***************
const equipmentDatainfo = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/equipmentData/info',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 判断运行分析的二级tab标签 ***************
const getEquFuncTab = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/fcx/getEquFuncTab',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 时序图的设备信息 ***************
const queryEquipByUnitListforMonitor = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/equQuery/queryEquipByUnitListforMonitor',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 时序图的图表数据 ***************
const newequQueryData = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/equQuery/newequQueryData',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 获取运行分析->时序图的图表数据 ***************
const getEquElectric = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/fcx/getEquElectric',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 获取运行分析->时序图的图表数据 ***************
const getRecent7daysAbRecord = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/fcx/getRecent7daysAbRecord',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 获取当月保养计划 ***************
const queryMonthListData = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/maintenance/queryMonthListData',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 获取近7天保养记录列表数据 ***************
const queryRecordData = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/maintenance/queryRecordData',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 单项目首页左侧监测信息列表数据 ***************
const getMonitorList = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/monitor/index/list',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 单项目首页左侧监测信息列表-工艺单元数据 ***************
const arealist = ({type = 'post', data = {}, success, error, requestDataType = '', enableAbortRequest = false}) => {
  sendAxios({
    url: '/monitor/index/arealist',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}
// ********************* 单项目首页左侧监测信息列表-设置默认工艺单元***************
const modifyDefault = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/technology/modifyDefault',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 设置默认的监测点和工艺单元***************
const monitorSetDefault = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/monitor/setDefault',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 单项目首页左侧监测信息列表-取消工艺单元***************
const cancelDefault = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/technology/cancelDefault',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 单项目下的水量趋势图数据 ***************
const waterYieldTrendData = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/monitor/index/waterYieldTrendData',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 单项目下的水质趋势图数据 ***************
const waterQualityTrendData = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/monitor/index/waterQualityTrendData',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 远程控制-校验令牌***************
const checkToken = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/monitor/control/checkToken',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 运维-本月维修饼图 ***************
const maintenanceRepairData = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/maintenance/index/repairData',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 运维-本月故障设备-未完成维修次数（工艺单元和设备分组）***************
const repairList = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/maintenance/index/unfinish/repairList',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 运维-本月维修次数-本月维修次数（按工艺单元分组）***************
const fixRecordThisMonth = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/maintenance/index/fixRecordThisMonth',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 运维-本月保养饼图 ***************
const planCount = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/maintenance/index/maintenanceRecord/planCount',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 运维-本月根据工艺单元分组计算实际保养和未保养次数 ***************
const queryCountByUnit = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/maintenance/index/maintain/queryCountByUnit',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 运维-维修保养排行前五 ***************
const rankList = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/maintenance/index/maintainBreakdown/rankList',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 运维-维修保养记录 ***************
const maintenanceRecordList = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/equipmentMgt/maintenanceRecord/list',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 运维-维修记录 ***************
const abnormityRecordList = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/maintenance/index/abnormityRecordList',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 运维-维修分析 ***************
const abnormityRecordChartData = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/maintenance/index/abnormityRecordChartData',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 运维-保养分析 ***************
const maintenanceChartData = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/maintenance/index/maintenanceChartData',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 河道-水量管理-整体页面-水量信息相关 ***************
const getProjectConfigObj = ({type = 'get', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/project/getProjectConfigObj',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 河道-水量管理-整体页面-水量信息相关 ***************
const waterYieldMonitorPointCount = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/waterYield/waterYieldMonitorPointCount',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 河道-水量管理-整体页面-获取出水口流量计读数 ***************
const waterGaugeValue = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/waterYield/waterGaugeValue',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 河道-水量管理-整体页面-统计水量预警个数 ***************
const warningCountByType = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/warning/warningCountByType',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 河道-水量管理-整体页面-进出水对比分析 ***************
const compareInAndOutChart = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/waterYield/compareInAndOutChart',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 河道-水量管理-整体页面-水量高峰分析 ***************
const waterInletPeakChart = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/waterYield/waterInletPeakChart',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 河道-水量管理-水量综合分钟-获取监测点 ***************
const getMonitorPoints = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/waterYield/getMonitorPoints',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 河道-水量管理-水量综合分析 ***************
const waterAllTrendChart = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/waterYield/waterAllTrendChart',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 河道-水量管理-水量查询 ***************
const getSearchWaterList = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/waterYield/getSearchWaterList',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 河道-水量管理-水量查询-删除信息 ***************
const deleteSearchData = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/waterYield/deleteSearchData',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 河道-水量管理-水量查询-更新信息 ***************
const updateSearchData = ({type = 'post', data = {}, success, error, requestDataType = '', async = true}) => {
  sendAxios({
    url: '/waterYield/updateSearchData',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 河道-水量管理-水量人工查询 ***************
const waterManualMonitorPoints = ({type = 'get', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/waterYield/waterManualMonitorPoints',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 河道-水量管理-水量人工查询-检查数据是否存在 ***************
const checkExist = ({type = 'post', data = {}, success, error, requestDataType = '', async = true}) => {
  sendAxios({
    url: '/waterYield/checkExist',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 河道-水量管理-水量人工查询-保存数据 ***************
const saveOrUpdateWaterResult = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/waterYield/saveOrUpdateWaterResult',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}

// ********************* 流程图(FIXME, 缺少接口) ***************
// ********************* 切换图纸 ***************
const getDrawingList = ({type = 'get', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/module/getDrawingList',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 切换图纸 ***************
const getDrawingName = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/module/getDrawingName',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}

// ********************* 水厂 项目看板***************
// ********************* 获取预警消息数量 ***************
const getWarningCount = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/warning/getWarningCount',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 查询消息数量 ***************
const checkMsgSum = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/msg/checkMsgSum',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 获取项目列表 ***************
const provinceList = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/project/province/list',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 获取水质监测点和监测指标 ***************
const getWaterQuailtyMonitorList = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/waterQuality/getWaterQuailtyMonitorList',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 获取设备运行情况 ***************
const countStatusByParam = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/model/countStatusByParam',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 获取设备在线离线数量和水量设计量 ***************
const countEquOnlineNum = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/multiModule/countEquOnlineNum',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 保存项目基本信息 ***************
const saveProjectInfo = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/project/saveProjectInfo',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 项目看板获取设备趋势 ***************
const getEquipCycleTime = ({type = 'get', data = {}, success, error, requestDataType = '', enableAbortRequest = false}) => {
  sendAxios({
    url: '/equQuery/getEquipCycleTime',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}
// ********************* 项目看板获取故障维修柱状图 ***************
const breakNum = ({type = 'get', data = {}, success, error, requestDataType = '', enableAbortRequest = false}) => {
  sendAxios({
    url: '/breakdown/breakNum',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}
// ********************* 项目看板获取预警类别 ***************
const groupTypeData = ({type = 'get', data = {}, success, error, requestDataType = '', enableAbortRequest = false}) => {
  sendAxios({
    url: '/warning/groupType/data',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}

// ******************************************************* 水质管理 **********************************
// ********************* 计算水质指标平均数 ***************
const queryAvgWater = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/waterQuality/queryAvgWater',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 获取水质达标率 ***************
const getWaterQualityForms = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/waterQuality/getWaterQualityForms',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 获取水质实时监测数据-返回table信息 ***************
const getWaterQualityData = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/waterQuality/getData',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 获取水质实时监测数据-返回json ***************
const getWaterQualityData1 = ({type = 'get', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/waterQuality/queryJsonData',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 获取实时监测数据-水质监测点和监测指标 ***************
const projectDictList = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/waterQuality/projectDictList',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 获取实时监测图表数据 ***************
const getQualityChartData = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/waterQuality/getQualityChartData',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 获取消减量图表数据 ***************
const getReductionData = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/waterQuality/getReductionData',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 获取达标率图表数据 ***************
const getStandardData = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/waterQuality/getStandardData',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 获取用户列表 ***************
const getProjectUsers = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/waterQuality/getProjectUsers',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 获取水质查询数据 ***************
const getQueryData = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/waterQuality/getQueryData',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 获取水质查询数据 ***************
const getPointsValue = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/waterQuality/getPointsValue',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 保存人工监测数据 ***************
const waterQualitySaveData = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/waterQuality/saveData',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 删除人工监测数据 ***************
const waterQualityDeleteData = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/waterQuality/deleteData',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// *****************************************************************bim模块（水厂版多模块界面）*****************************************************************
// ********************* 搜索项目 ***************
const searchProjectList = ({type = 'get', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/map/searchProjectList',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 获取项目 ***************
const getGisEntireInfo = ({type = 'post', data = {}, success, error, requestDataType = ''}) => {
  sendAxios({
    url: '/map/getGisEntireInfo',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType
  })
}
// ********************* 获取地图的区域边界点 ***************
const getGisDistrictInfo = ({type = 'post', data = {}, success, error, requestDataType = '', responseType = 'json'}) => {
  sendAxios({
    url: '/map/districtInfo',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    responseType: responseType
  })
}
// *****************************************************************水厂抄表功能*****************************************************************
// ********************* 获取模块检测时间 ***************
const getModuleInspectTime = ({type = 'post', data = {}, success, error, requestDataType = '', responseType = 'json'}) => {
  sendAxios({
    url: '/dataConfig/getModuleInspectTime',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    responseType: responseType
  })
}
// ********************* 获取项目抄表权限 ***************
const obtainJumpItems = ({type = 'post', data = {}, success, error, requestDataType = '', responseType = 'json'}) => {
  sendAxios({
    url: '/dataConfig/obtainJumpItems',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    responseType: responseType
  })
}
// ********************* 获取所有指标项 ***************
const listAllDicItem = ({type = 'post', data = {}, success, error, requestDataType = '', responseType = 'json'}) => {
  sendAxios({
    url: '/inspect/listAllDicItem',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    responseType: responseType
  })
}
// ********************* 获取岗位列表 ***************
const getDataPostsList = ({type = 'post', data = {}, success, error, requestDataType = '', responseType = 'json'}) => {
  sendAxios({
    url: '/positionConfig/obtainLists',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    responseType: responseType
  })
}
// ********************* 获取岗位图标列表 ***************
const getDataPostsIconList = ({type = 'post', data = {}, success, error, requestDataType = '', responseType = 'json'}) => {
  sendAxios({
    url: '/positionConfig/obtainPositionIcons',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    responseType: responseType
  })
}
// ********************* 删除岗位图标列表 ***************
const deletePostsIcon = ({type = 'post', data = {}, success, error, requestDataType = '', responseType = 'json'}) => {
  sendAxios({
    url: '/positionConfig/removePositionIcons',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    responseType: responseType
  })
}
// ********************* 获取分组列表 ***************
const getDataGroupList = ({type = 'post', data = {}, success, error, requestDataType = '', responseType = 'json'}) => {
  sendAxios({
    url: '/dataConfig/getDataGroupList',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    responseType: responseType
  })
}
// ********************* 获取指标配置列表 ***************
const getIndexConfigList = ({type = 'post', data = {}, success, error, requestDataType = '', responseType = 'json'}) => {
  sendAxios({
    url: '/dataConfig/obtainItems',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    responseType: responseType
  })
}
// ********************* 添加或修改分组 ***************
const addOrUpdateDataGroup = ({type = 'post', data = {}, success, error, requestDataType = '', responseType = 'json'}) => {
  sendAxios({
    url: '/dataConfig/addOrUpdateDataGroup',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    responseType: responseType
  })
}
// ********************* 删除分组 ***************
const removeIndexGroup = ({type = 'post', data = {}, success, error, requestDataType = '', responseType = 'json'}) => {
  sendAxios({
    url: '/dataConfig/removeDataGroup',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    responseType: responseType
  })
}
// ********************* 检查重名 ***************
const checkConfigName = ({type = 'post', data = {}, success, error, requestDataType = '', responseType = 'json'}) => {
  sendAxios({
    url: '/dataConfig/checkConfigName',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    responseType: responseType
  })
}
// ********************* 改变抄表指标项列表显示顺序 ***************
const changeOrderInList = ({type = 'post', data = {}, success, error, requestDataType = '', responseType = 'json'}) => {
  sendAxios({
    url: '/dataConfig/changeOrderInList',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    responseType: responseType
  })
}
// ********************* 更改组内指标显示顺序 ***************
const changeOrderInGroup = ({type = 'post', data = {}, success, error, requestDataType = '', responseType = 'json'}) => {
  sendAxios({
    url: '/dataConfig/changeOrderInGroup',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    responseType: responseType
  })
}
// ********************* 获取单个抄表配置详情 ***************
const getConfigDetail = ({type = 'post', data = {}, success, error, requestDataType = '', responseType = 'json'}) => {
  sendAxios({
    url: '/dataConfig/getConfigDetail',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    responseType: responseType
  })
}
// ********************* 配置显示列表 ***************
const configShowDataInList = ({type = 'post', data = {}, success, error, requestDataType = '', responseType = 'json'}) => {
  sendAxios({
    url: '/dataConfig/configShowDataInList',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    responseType: responseType
  })
}
// ********************* 获取模块列表 ***************
const moduleListData = ({type = 'post', data = {}, success, error, requestDataType = '', responseType = 'json'}) => {
  sendAxios({
    url: '/dataConfig/moduleListData',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    responseType: responseType
  })
}
// ********************* 保存配置(指标) ***************
const saveDicConfig = ({type = 'post', data = {}, success, error, requestDataType = '', responseType = 'json'}) => {
  sendAxios({
    url: '/dataConfig/save',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    responseType: responseType
  })
}
// ********************* 删除单个配置 ***************
const deleteDicConfig = ({type = 'post', data = {}, success, error, requestDataType = '', responseType = 'json'}) => {
  sendAxios({
    url: '/dataConfig/delete',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    responseType: responseType
  })
}
// ********************* 获取需要展示的配置列表 ***************
const getShowDataInList = ({type = 'post', data = {}, success, error, requestDataType = '', responseType = 'json'}) => {
  sendAxios({
    url: '/dataConfig/getShowDataInList',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    responseType: responseType
  })
}
// ********************* 单个模块修改抄表检查时间 ***************
const modifyInspectTime = ({type = 'post', data = {}, success, error, requestDataType = '', responseType = 'json'}) => {
  sendAxios({
    url: '/dataConfig/modifyInspectTime',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    responseType: responseType
  })
}
// ********************* 获取工艺单元 ***************
const obtainProcessUnits = ({type = 'post', data = {}, success, error, requestDataType = '', responseType = 'json'}) => {
  sendAxios({
    url: '/dataConfig/obtainProcessUnits',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    responseType: responseType
  })
}
// ********************* 获取含有指标项的组 ***************
const obtainGroupAndItems = ({type = 'post', data = {}, success, error, requestDataType = '', responseType = 'json'}) => {
  sendAxios({
    url: '/dataConfig/obtainGroupAndItems',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    responseType: responseType
  })
}
// ********************* 保存功能模块的录入时间、列表配置、指标排序 ***************
const modifyDataConfigModule = ({type = 'post', data = {}, success, error, requestDataType = '', responseType = 'json'}) => {
  sendAxios({
    url: '/dataConfig/modifyModule',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    responseType: responseType
  })
}

// ********************* 保存功能模块的录入时间、列表配置、指标排序 ***************
const zeroGetTableHead = ({type = 'post', data = {}, success, error, requestDataType = '', responseType = 'json'}) => {
  sendAxios({
    url: '/zero/obtainHeadForGrid',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    responseType: responseType
  })
}
// ********************* 获取零点抄表记录列表 ***************
const zeroGetDataList = ({type = 'post', data = {}, success, error, requestDataType = '', responseType = 'json', enableAbortRequest = false}) => {
  sendAxios({
    url: '/zero/obtainListsByDate',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    responseType: responseType,
    enableAbortRequest: enableAbortRequest
  })
}
// ********************* 查看某一条零点抄表记录 ***************
const zeroRecordDetail = async ({type = 'post', data = {}, success, error, requestDataType = '', responseType = 'json', async = true, enableAbortRequest = false}) => {
  let obj = {
    url: '/zero/obtainSingleRecord',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    responseType: responseType,
    enableAbortRequest: enableAbortRequest
  }
  if (async) {
    sendAxios(obj)
  } else {
    await sendAxios(obj)
  }
}
// ********************* 删除零点记录 ***************
const zeroDelete = ({type = 'post', data = {}, success, error, requestDataType = '', responseType = 'json', enableAbortRequest = false}) => {
  sendAxios({
    url: '/zero/delete',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    responseType: responseType,
    enableAbortRequest: enableAbortRequest
  })
}
// ********************* 校验零点记录的日期 ***************
const zeroCheckDate = async ({type = 'post', data = {}, success, error, requestDataType = '', responseType = 'json', async = true, enableAbortRequest = false}) => {
  let obj = {
    url: '/zero/checkDate',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    responseType: responseType,
    enableAbortRequest: enableAbortRequest
  }
  if (async) {
    sendAxios(obj)
  } else {
    await sendAxios(obj)
  }
}
// ********************* 保存编辑、审核零点记录 ***************
const zeroUpdate = ({type = 'post', data = {}, success, error, requestDataType = '', responseType = 'json', enableAbortRequest = false}) => {
  sendAxios({
    url: '/zero/update',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    responseType: responseType,
    enableAbortRequest: enableAbortRequest
  })
}

// ********************* 获取交接班记录的表头数据 ***************
const handoverGetTableHead = ({type = 'post', data = {}, success, error, requestDataType = '', responseType = 'json', enableAbortRequest = false}) => {
  sendAxios({
    url: '/handover/obtainHeadForGrid',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    responseType: responseType,
    enableAbortRequest: enableAbortRequest
  })
}
// ********************* 获取交接班记录列表数据 ***************
const handoverGetDataList = ({type = 'post', data = {}, success, error, requestDataType = '', responseType = 'json', enableAbortRequest = false}) => {
  sendAxios({
    url: '/handover/obtainListsByDate',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    responseType: responseType,
    enableAbortRequest: enableAbortRequest
  })
}
// ********************* 查看某一条交接班记录 ***************
const handoverRecordDetail = async ({type = 'post', data = {}, success, error, requestDataType = '', responseType = 'json', async = true, enableAbortRequest = false}) => {
  let obj = {
    url: '/handover/obtainSingleRecord',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    responseType: responseType,
    enableAbortRequest: enableAbortRequest
  }
  if (async) {
    sendAxios(obj)
  } else {
    await sendAxios(obj)
  }
}
// ********************* 删除交接班记录 ***************
const handoverDelete = ({type = 'post', data = {}, success, error, requestDataType = '', responseType = 'json', enableAbortRequest = false}) => {
  sendAxios({
    url: '/handover/delete',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    responseType: responseType,
    enableAbortRequest: enableAbortRequest
  })
}
// ********************* 校验交接班的日期 ***************
const handoverCheckDate = async ({type = 'post', data = {}, success, error, requestDataType = '', responseType = 'json', async = true, enableAbortRequest = false}) => {
  let obj = {
    url: '/handover/checkDate',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    responseType: responseType,
    enableAbortRequest: enableAbortRequest
  }
  if (async) {
    sendAxios(obj)
  } else {
    await sendAxios(obj)
  }
}
// ********************* 保存编辑、审核交接班记录 ***************
const handoverUpdate = ({type = 'post', data = {}, success, error, requestDataType = '', responseType = 'json', enableAbortRequest = false}) => {
  sendAxios({
    url: '/handover/update',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    responseType: responseType,
    enableAbortRequest: enableAbortRequest
  })
}

// ********************* 获取在线数据列表表头 ***************
const onlineGetTableHead = ({type = 'post', data = {}, success, error, requestDataType = '', responseType = 'json', enableAbortRequest = false}) => {
  sendAxios({
    url: '/online/obtainHeadForGrid',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    responseType: responseType,
    enableAbortRequest: enableAbortRequest
  })
}
// ********************* 获取在线数据列表 ***************
const onlineGetDataList = ({type = 'post', data = {}, success, error, requestDataType = '', responseType = 'json', enableAbortRequest = false}) => {
  sendAxios({
    url: '/online/obtainListsByDate',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    responseType: responseType,
    enableAbortRequest: enableAbortRequest
  })
}
// ********************* 删除在线数据列表 ***************
const onlineDelete = ({type = 'get', data = {}, success, error, requestDataType = '', responseType = 'json', enableAbortRequest = false}) => {
  sendAxios({
    url: '/online/delete',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    responseType: responseType,
    enableAbortRequest: enableAbortRequest
  })
}
// ********************* 新增或更新在线数据列表 ***************
const onlineAddOrUpdate = ({type = 'post', data = {}, success, error, requestDataType = '', responseType = 'json', enableAbortRequest = false}) => {
  sendAxios({
    url: '/online/addOrUpdate',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    responseType: responseType,
    enableAbortRequest: enableAbortRequest
  })
}
// ********************* 校验在线数据的日期 ***************
const onlineCheckDate = async ({type = 'post', data = {}, success, error, requestDataType = '', responseType = 'json', async = true, enableAbortRequest = false}) => {
  let obj = {
    url: '/online/checkDate',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    responseType: responseType,
    enableAbortRequest: enableAbortRequest
  }
  if (async) {
    sendAxios(obj)
  } else {
    await sendAxios(obj)
  }
}
// ********************* 查看在线数据列表某一条数据 ***************
const onlineRecordDetail = async ({type = 'post', data = {}, success, error, requestDataType = '', responseType = 'json', async = true, enableAbortRequest = false}) => {
  let obj = {
    url: '/online/obtainSingleRecordOrConfigs',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    responseType: responseType,
    enableAbortRequest: enableAbortRequest
  }
  if (async) {
    sendAxios(obj)
  } else {
    await sendAxios(obj)
  }
}
// ********************* 获取填报人 ***************
const onlineGetUser = ({type = 'post', data = {}, success, error, requestDataType = '', responseType = 'json', enableAbortRequest = false}) => {
  sendAxios({
    url: '/online/obtainUsers',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    responseType: responseType,
    enableAbortRequest: enableAbortRequest
  })
}
// ********************* 设备台时--添加或编辑 ***************
const equTimeAddOrUpdate = ({type = 'post', data = {}, success, error, requestDataType = '', responseType = 'json', enableAbortRequest = false}) => {
  sendAxios({
    url: '/deviceHoursData/addOrUpdate',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    responseType: responseType,
    enableAbortRequest: enableAbortRequest
  })
}
// ********************* 设备台时--验证日期 ***************
const equTimeCheckDate = async ({type = 'get', data = {}, success, error, requestDataType = '', responseType = 'json', async = true, enableAbortRequest = false}) => {
  let obj = {
    url: '/deviceHoursData/checkDate',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    responseType: responseType,
    enableAbortRequest: enableAbortRequest
  }
  if (async) {
    sendAxios(obj)
  } else {
    await sendAxios(obj)
  }
}
// ********************* 设备台时--删除数据 ***************
const equTimeDelete = ({type = 'get', data = {}, success, error, requestDataType = '', responseType = 'json', enableAbortRequest = false}) => {
  sendAxios({
    url: '/deviceHoursData/delete',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    responseType: responseType,
    enableAbortRequest: enableAbortRequest
  })
}
// ********************* 设备台时--获取表头 ***************
const equTimeGetTableHead = ({type = 'get', data = {}, success, error, requestDataType = '', responseType = 'json', enableAbortRequest = false}) => {
  sendAxios({
    url: '/deviceHoursData/obtainHeadForGrid',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    responseType: responseType,
    enableAbortRequest: enableAbortRequest
  })
}
// ********************* 设备台时--获取列表数据 ***************
const equTimeGetDataList = ({type = 'get', data = {}, success, error, requestDataType = '', responseType = 'json', enableAbortRequest = false}) => {
  sendAxios({
    url: '/deviceHoursData/obtainListsByDate',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    responseType: responseType,
    enableAbortRequest: enableAbortRequest
  })
}
// ********************* 设备台时--获取某一条数据信息或者新增的配置 ***************
const equTimeRecordDetail = async ({type = 'get', data = {}, success, error, requestDataType = '', responseType = 'json', async = true, enableAbortRequest = false}) => {
  let obj = {
    url: '/deviceHoursData/obtainSingleRecordOrConfigs',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    responseType: responseType,
    enableAbortRequest: enableAbortRequest
  }
  if (async) {
    sendAxios(obj)
  } else {
    await sendAxios(obj)
  }
}
// ********************* 设备台时--获取某一条数据信息或者新增的配置 ***************
const equTimeGetUser = ({type = 'get', data = {}, success, error, requestDataType = '', responseType = 'json', enableAbortRequest = false}) => {
  sendAxios({
    url: '/deviceHoursData/obtainUsers',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    responseType: responseType,
    enableAbortRequest: enableAbortRequest
  })
}

// ********************* 获取DO列表表头 ***************
const doDataGetTableHead = ({type = 'post', data = {}, success, error, requestDataType = '', responseType = 'json', enableAbortRequest = false}) => {
  sendAxios({
    url: '/doData/obtainHeadForGrid',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    responseType: responseType,
    enableAbortRequest: enableAbortRequest
  })
}
// ********************* 获取DO数据列表 ***************
const doDataGetDataList = ({type = 'post', data = {}, success, error, requestDataType = '', responseType = 'json', enableAbortRequest = false}) => {
  sendAxios({
    url: '/doData/obtainListsByDate',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    responseType: responseType,
    enableAbortRequest: enableAbortRequest
  })
}
// ********************* 删除DO数据列表 ***************
const doDataDelete = ({type = 'get', data = {}, success, error, requestDataType = '', responseType = 'json', enableAbortRequest = false}) => {
  sendAxios({
    url: '/doData/delete',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    responseType: responseType,
    enableAbortRequest: enableAbortRequest
  })
}
// ********************* 新增或更新在线数据列表 ***************
const doDataAddOrUpdate = ({type = 'post', data = {}, success, error, requestDataType = '', responseType = 'json', enableAbortRequest = false}) => {
  sendAxios({
    url: '/doData/addOrUpdate',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    responseType: responseType,
    enableAbortRequest: enableAbortRequest
  })
}
// ********************* 校验DO的日期 ***************
const doDataCheckDate = async ({type = 'post', data = {}, success, error, requestDataType = '', responseType = 'json', async = true, enableAbortRequest = false}) => {
  let obj = {
    url: '/doData/checkDate',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    responseType: responseType,
    enableAbortRequest: enableAbortRequest
  }
  if (async) {
    sendAxios(obj)
  } else {
    await sendAxios(obj)
  }
}
// ********************* 查看DO列表某一条数据 ***************
const doDataRecordDetail = async ({type = 'post', data = {}, success, error, requestDataType = '', responseType = 'json', async = true, enableAbortRequest = false}) => {
  let obj = {
    url: '/doData/obtainSingleRecordOrConfigs',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    responseType: responseType,
    enableAbortRequest: enableAbortRequest
  }
  if (async) {
    sendAxios(obj)
  } else {
    await sendAxios(obj)
  }
}
// ********************* 获取设备列表 ***************
const getMonitorEquipmentList = ({type = 'post', data = {}, success, error, requestDataType = '', responseType = 'json', enableAbortRequest = false}) => {
  sendAxios({
    url: '/model/getMonitorEquipmentList',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    responseType: responseType,
    enableAbortRequest: enableAbortRequest
  })
}
// ********************* 获取设备级别列表 ***************
const getEquipmentLevelList = ({type = 'get', data = {}, success, error, requestDataType = '', responseType = 'json', enableAbortRequest = false}) => {
  sendAxios({
    url: '/equipmentMgt/getEquipmentLevelList',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    responseType: responseType,
    enableAbortRequest: enableAbortRequest
  })
}
// ********************* 获取设备运行分析数据 ***************
const getEquRunCountStatus = ({type = 'get', data = {}, success, error, requestDataType = '', responseType = 'json', enableAbortRequest = false}) => {
  sendAxios({
    url: '/equipmentMgt/runAnalysis/countStatus',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    responseType: responseType,
    enableAbortRequest: enableAbortRequest
  })
}
// ********************* 获取设备运行排行数据 ***************
const runTimesRanking = ({type = 'get', data = {}, success, error, requestDataType = '', responseType = 'json', enableAbortRequest = false}) => {
  sendAxios({
    url: '/equipmentMgt/runAnalysis/runTimesRanking',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    responseType: responseType,
    enableAbortRequest: enableAbortRequest
  })
}
// ********************* 获取设备运行统计数据 ***************
const countStatusForChart = ({type = 'get', data = {}, success, error, requestDataType = '', responseType = 'json', enableAbortRequest = false}) => {
  sendAxios({
    url: '/equipmentMgt/runAnalysis/countStatusForChart',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    responseType: responseType,
    enableAbortRequest: enableAbortRequest
  })
}
// *****************************************************************水厂抄表功能*****************************************************************
// ********************* 获取项目列表 ***************
const obtainProjectMessageForSelect = ({type = 'post', data = {}, success, error, requestDataType = '', responseType = 'json'}) => {
  sendAxios({
    url: '/report/obtainProjectMessageForSelect',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    responseType: responseType
  })
}
// ********************* 获取报表列表 ***************
const obtainReportMessageForGrid = ({type = 'post', data = {}, success, error, requestDataType = '', responseType = 'json'}) => {
  sendAxios({
    url: '/report/obtainReportMessageForGrid',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    responseType: responseType
  })
}
// ********************* 获取模板列表 ***************
const obtainReportTemplateForSelect = ({type = 'post', data = {}, success, error, requestDataType = '', responseType = 'json'}) => {
  sendAxios({
    url: '/report/obtainReportTemplateForSelect',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    responseType: responseType
  })
}
// ********************* 删除模板列表 ***************
const removeTemplate = ({type = 'post', data = {}, success, error, requestDataType = '', responseType = 'json'}) => {
  sendAxios({
    url: '/report/removeTemplate',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    responseType: responseType
  })
}
// ********************* 操作映射( 报表绑定模板 ) ***************
const reportFormOperateMapping = ({type = 'post', data = {}, success, error, requestDataType = '', responseType = 'json'}) => {
  sendAxios({
    url: '/report/operateMapping',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    responseType: responseType
  })
}
// ********************* 模板上传 ***************
const uploaderReportTemplate = ({type = 'post', data = {}, success, error, requestDataType = '', responseType = 'json'}) => {
  sendAxios({
    url: '/report/uploader',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    responseType: responseType
  })
}
// *****************************************************************水厂项目管理相关*****************************************************************
// ********************* 添加或修改岗位 ***************
const addOrUpdatePost = ({type = 'post', data = {}, success, error, requestDataType = '', responseType = 'json'}) => {
  sendAxios({
    url: '/positionConfig/addOrUpdateMessage',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    responseType: responseType
  })
}
// ********************* 删除岗位 ***************
const removePost = ({type = 'post', data = {}, success, error, requestDataType = '', responseType = 'json'}) => {
  sendAxios({
    url: '/positionConfig/removeMessage',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    responseType: responseType
  })
}
// ********************* 获取班组列表 ***************
const getTeamList = ({type = 'post', data = {}, success, error, requestDataType = '', responseType = 'json'}) => {
  sendAxios({
    url: '/teamManage/obtainLists',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    responseType: responseType
  })
}
// ********************* 添加或修改班组 ***************
const addOrUpdateTeam = ({type = 'post', data = {}, success, error, requestDataType = '', responseType = 'json'}) => {
  sendAxios({
    url: '/teamManage/addOrUpdateMessage',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    responseType: responseType
  })
}
// ********************* 删除岗位 ***************
const removeTeam = ({type = 'post', data = {}, success, error, requestDataType = '', responseType = 'json'}) => {
  sendAxios({
    url: '/teamManage/removeMessage',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    responseType: responseType
  })
}
// ********************* 水厂-运行日报配置-获取配置 ***************
const configReportList = ({type = 'get', data = {}, success, error, requestDataType = '', responseType = 'json'}) => {
  sendAxios({
    url: '/paper/configReportList',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    responseType: responseType
  })
}
// ********************* 水厂-运行日报配置-保存配置 ***************
const paperSaveConfig = ({type = 'post', data = {}, success, error, requestDataType = '', responseType = 'json'}) => {
  sendAxios({
    url: '/paper/saveConfig',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    responseType: responseType
  })
}
// ********************* 水厂-运行日报配置-获取接受人列表 ***************
const designUserList = ({type = 'post', data = {}, success, error, requestDataType = '', responseType = 'json'}) => {
  sendAxios({
    url: '/user/design/user/list',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    responseType: responseType
  })
}
// ********************* 根据sessionId获取用户信息 ***************
const getUserInfo = async ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  let obj = {
    url: '/user/getUserInfo',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  }
  if (async) {
    sendAxios(obj)
  } else {
    await sendAxios(obj)
  }
}
// ********************* 获取项目基本信息 ***************
const getProjectInfoById = ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  sendAxios({
    url: '/project/getProjectInfoById',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}
// ************************************ 根据项目id集合获取业务类型 ******************************
const getBusinessTypeList = ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  sendAxios({
    url: '/regPlan/getBusinessTypeList',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}

// ********************* 新增外协单位 ***************
const insertOutsourcingUnit = ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  sendAxios({
    url: '/outsourcingUnit/insertOutsourcingUnit',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}
// ********************* 删除外协单位 ***************
const deleteOutsourcingUnitById = ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  sendAxios({
    url: '/outsourcingUnit/deleteOutsourcingUnitById',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}
// ********************* 修改外协单位 ***************
const updateOutsourcingUnit = ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  sendAxios({
    url: '/outsourcingUnit/updateOutsourcingUnit',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}
// ********************* 根据条件查询外协单位 ***************
const selectOutsourcingUnit = ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  sendAxios({
    url: '/outsourcingUnit/selectOutsourcingUnit',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}
// ********************* 根据id查询外协单位 ***************
const selectOutsourcingUnitById = ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  sendAxios({
    url: '/outsourcingUnit/selectOutsourcingUnitById',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}

// ************************************ 水厂版设备故障记录列表 ******************************
const breakdownRecordList = ({type = 'post', data = {}, success, error, requestDataType = '', enableAbortRequest = false}) => {
  let obj = {
    url: '/breakdown/list/data',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  }
  sendAxios(obj)
}
// ************************************ 水厂水量管理 ******************************
// ************************************ 获取监测点树 ******************************
const monitorTreeGroupByType = ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  sendAxios({
    url: '/model/monitorTreeGroupByType',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}
// ************************************ 水厂计划管理 ******************************
// ************************************ 获取日常计划类型列表 ******************************
const getPlanTypeList = async ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  let obj = {
    url: '/plan/daily/getPlanFunction',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  }
  if (async) {
    sendAxios(obj)
  } else {
    await sendAxios(obj)
  }
}
// ************************************ 获取今日计划 ******************************
const getDayPlan = async ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  let obj = {
    url: '/rotaPlan/getDayPlan',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  }
  if (async) {
    sendAxios(obj)
  } else {
    await sendAxios(obj)
  }
}
// ************************************ 按日常计划类型获取今日计划 ******************************
const getDayPlanByPlanTypes = async ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  let obj = {
    url: '/rotaPlan/getDayPlanByPlanTypes',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  }
  if (async) {
    sendAxios(obj)
  } else {
    await sendAxios(obj)
  }
}
// ************************************ 获取排班计划 ******************************
const rotaPlanDetail = async ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  let obj = {
    url: '/rotaPlan/detail/data',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  }
  if (async) {
    sendAxios(obj)
  } else {
    await sendAxios(obj)
  }
}
// ************************************ 根据日常计划类型获取排班计划 ******************************
const rotaPlanDetailByPlanTypes = async ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  let obj = {
    url: '/rotaPlan/getCountByPlanTypes',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  }
  if (async) {
    sendAxios(obj)
  } else {
    await sendAxios(obj)
  }
}
// ************************************ 更新排班计划 ******************************
const updatePlan = ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  sendAxios({
    url: '/rotaPlan/detail/updatePlan',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}

// ************************************ 获取计划水量表头 ******************************
const getWaterVolumeHeader = ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  sendAxios({
    url: '/plan/waterVolume/getHeaders',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}
// ************************************ 获取计划水量列表 ******************************
const getWaterVolumeList = ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  sendAxios({
    url: '/plan/waterVolume/getLists',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}
// ************************************ 保存新增或编辑的计划水量的数据 ******************************
const saveWaterVolumeData = ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  sendAxios({
    url: '/plan/waterVolume/save',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}
// ************************************ 删除计划水量的数据 ******************************
const removeWaterVolumeData = ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  sendAxios({
    url: '/plan/waterVolume/remove',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}
// ************************************ 获取生产计划表头 ******************************
const getProductionHead = ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  sendAxios({
    url: '/plan/production/getHeaders',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}
// ************************************ 获取生产计划数据 ******************************
const getProductionList = ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  sendAxios({
    url: '/plan/production/getLists',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}
// ************************************ 删除生产计划数据 ******************************
const removeProductionData = ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  sendAxios({
    url: '/plan/production/remove',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}
// ************************************ 保存新增/修改生产计划数据 ******************************
const saveProductionData = ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  sendAxios({
    url: '/plan/production/save',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}

// ************************************ 获取计划进度表头 ******************************
const getPlanProgressHead = ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  sendAxios({
    url: '/plan/progress/getHeaders',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}
// ************************************ 获取计划进度数据 ******************************
const getPlanProgressList = ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  sendAxios({
    url: '/plan/progress/getLists',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}

// ************************************ 项目管理 ******************************
// ************************************ 获取项目配置 ******************************
const listProjectConfig = ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  sendAxios({
    url: '/project/listProjectConfig',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}

// ************************************ 排泥管理 ******************************
// ************************************ 获取污泥单价列表 ******************************
const getMudPriceList = ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  sendAxios({
    url: '/soilDischargingPrice/getList',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}
// ************************************ 新增污泥单价 ******************************
const addMudPrice = ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  sendAxios({
    url: '/soilDischargingPrice/insert',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}
// ************************************ 修改污泥单价 ******************************
const updateMudPrice = ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  sendAxios({
    url: '/soilDischargingPrice/update',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}
// ************************************ 删除污泥单价 ******************************
const deleteMudPrice = ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  sendAxios({
    url: '/soilDischargingPrice/delete',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}

// ************************************ 药剂管理 ******************************
// ************************************ 根据项目id获取药剂名列表 ******************************
const getMedicamentList = ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  sendAxios({
    url: '/medicamentPrice/getMedicamentList',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}
// ************************************ 根据项目id和药剂id获取药剂成本列表 ******************************
const getMedicamentPriceList = ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  sendAxios({
    url: '/medicamentPrice/getListByMedicamentId',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}
// ************************************ 删除药剂单价 ******************************
const deleteMedicamentPrice = ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  sendAxios({
    url: '/medicamentPrice/delete',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}

// ************************************ 新增药剂单价 ******************************
const addMedicamentPrice = ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  sendAxios({
    url: '/medicamentPrice/insert',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}
// ************************************ 修改药剂单价 ******************************
const updateMedicamentPrice = ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  sendAxios({
    url: '/medicamentPrice/update',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}

// ************************************ 水厂-巡检计划查看 ******************************
const getInspectPlan = ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  sendAxios({
    url: '/inspect/getInspectPlan',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}

// ************************************ 水厂-巡检计划查看巡检点列表 ******************************
const listAllInspectPointList = ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  sendAxios({
    url: '/inspect/listAllInspectPointList',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}

// ************************************ 水厂-巡检记录列表 ******************************
const getUserInspectRecordList = ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  sendAxios({
    url: '/inspect/getUserInspectRecordList',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}

// ************************************ 水厂-工艺单元下拉选择 ******************************
const getMstProcessAreaList = ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  sendAxios({
    url: '/technology/getMstProcessAreaList',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}

// ************************************ 水厂-设备级别下拉选择 ******************************
const equlevellist = ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  sendAxios({
    url: '/equlevel/levellist',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}

// ************************************ 水厂-巡检记录详情列表 ******************************
const getUserInspectRecordDetail = ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  sendAxios({
    url: '/inspect/getUserInspectRecordDetail',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}

const historicTrack = ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  sendAxios({
    url: '/inspect/historicTrack',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}

// ************************************ 水厂-巡检任务列表-本天 ******************************
const loadInspectTaskList = ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  sendAxios({
    url: '/inspect/loadInspectTaskList',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}
// ************************************ 水厂-巡检任务列表-除本天 ******************************
const loadInspectPlanTaskList = ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  sendAxios({
    url: '/inspect/loadInspectPlanTaskList',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}
// ************************************ 水厂-巡检任务列表-统计 ******************************
const statisInspectData = ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  sendAxios({
    url: '/inspect/statisInspectData',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}
// ************************************ 水厂-巡检任务的参与人员******************************
const loadUserListByTaskId = ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  sendAxios({
    url: '/inspect/loadUserListByTaskId ',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}
// ************************************ 水厂-巡检轨迹 ******************************
const historicTrackByTaskId = ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  sendAxios({
    url: '/inspect/historicTrackByTaskId',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}
// ************************************ 仓库维护-列表 ******************************
const depositoryList = ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  sendAxios({
    url: '/depositoryMgt/depositoryList',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}
// ************************************ 仓库维护-新增 ******************************
const addDepository = ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  sendAxios({
    url: '/depositoryMgt/addDepository',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}
// ************************************ 仓库维护-编辑 ******************************
const updateDepository = ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  sendAxios({
    url: '/depositoryMgt/updateDepository',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}

// ************************************ 仓库维护-删除 ******************************
const deleteDepository = ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  sendAxios({
    url: '/depositoryMgt/deleteDepository',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}

// ************************************ 物料管理-物料列表 ******************************
const materialList = ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  sendAxios({
    url: '/depositoryMgt/materialList',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}

// ************************************ 物料管理-添加物料 ******************************
const addMaterialData = ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  sendAxios({
    url: '/depositoryMgt/addMaterialData',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}

// ************************************ 物料管理-更新物料 ******************************
const updateMaterialData = ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  sendAxios({
    url: '/depositoryMgt/updateMaterialData',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}

// ************************************ 物料管理-删除物料 ******************************
const deleteMaterial = ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  sendAxios({
    url: '/depositoryMgt/deleteMaterial',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}

// ************************************ 物料管理-获取物料详情 ******************************
const getMaterialDetail = ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  sendAxios({
    url: '/depositoryMgt/getMaterialDetail',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}

// ************************************ 物料管理-物料记录 ******************************
const materialDataLog = ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  sendAxios({
    url: '/depositoryMgt/materialDataLog',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}


// ************************************ 获取入库列表 ******************************
const getInboundData = ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  sendAxios({
    url: '/depositoryMgt/getInboundData',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}

// ************************************ 获取入库单号 ******************************
const getInboundCode = ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  sendAxios({
    url: '/depositoryMgt/getInboundCode',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}


// ************************************ 获取库存接口 ******************************
const getMaterialRestNum = ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  sendAxios({
    url: '/depositoryMgt/getMaterialRestNum',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}

// ************************************ 新增入库记录 ******************************
const saveInbound = ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  sendAxios({
    url: '/depositoryMgt/saveInbound',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}

// ************************************ 编辑入库记录 ******************************
const editInbound = ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  sendAxios({
    url: '/depositoryMgt/editInbound',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}

// ************************************ 查看入库记录 ******************************
const viewInboundRecord = ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  sendAxios({
    url: '/depositoryMgt/viewInboundRecord',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}

// ************************************ 删除入库记录 ******************************
const delInbound = ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  sendAxios({
    url: '/depositoryMgt/delInbound',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}

// ************************************ 获取库存查询列表 ******************************
const inventoryList = ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  sendAxios({
    url: '/depositoryMgt/inventoryList',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}

// ************************************ 获取出库记录列表 ******************************
const getOutboundData = ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  sendAxios({
    url: '/depositoryMgt/getOutboundData',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}

// ************************************ 获取出库单号 ******************************
const getOutboundCode = ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  sendAxios({
    url: '/depositoryMgt/getOutboundCode',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}

// ************************************ 编辑出库记录 ******************************
const editOutbound = ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  sendAxios({
    url: '/depositoryMgt/editOutbound',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}

// ************************************ 新增出库记录 ******************************
const saveOutbound = ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  sendAxios({
    url: '/depositoryMgt/saveOutbound',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}

// ************************************ 删除出库记录 ******************************
const delOutbound = ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  sendAxios({
    url: '/depositoryMgt/delOutbound',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}

// ************************************ 获取出库详情 ******************************
const viewOutboundRecord = ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  sendAxios({
    url: '/depositoryMgt/viewOutboundRecord',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}


// ************************************ 获取报损单列表 ******************************
const lossDataList = ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  sendAxios({
    url: '/depositoryMgt/lossDataList',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}

// ************************************ 新增报损 ******************************
const addLoss = ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  sendAxios({
    url: '/depositoryMgt/addLoss',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}

// ************************************ 编辑报损 ******************************
const updateLoss = ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  sendAxios({
    url: '/depositoryMgt/updateLoss',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}

// ************************************ 删除报损 ******************************
const deleteLoss = ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  sendAxios({
    url: '/depositoryMgt/deleteLoss',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}

// ************************************ 获取报损详情 ******************************
const getLossrecord = ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  sendAxios({
    url: '/depositoryMgt/getLossrecord',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}

// ************************************ 获取当前库存数据 ******************************
const getNowInventory  = ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  sendAxios({
    url: '/depositoryMgt/getNowInventory ',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}

// ************************************ 获取库存查询列表 ******************************
const billList  = ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  sendAxios({
    url: '/depositoryMgt/billList ',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}

//   { requestName: 'delCamera', api: '/camera/deleteCamera' }, // 删除摄像头
//   { requestName: 'getInventoryBasicInfo', api: '/depositoryMgt/getInventoryBasicInfo' }, // 获取库存查询基础信息

// ************************************ 获取文件列表 ******************************
const getFileList = ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  sendAxios({
    url: '/file/getFileList',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}
// ************************************ 保存文件信息到数据库 ******************************
const saveFiles = ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  sendAxios({
    url: '/file/saveFiles',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}
// ************************************ 删除数据库中的文件信息 ******************************
const deleteFiles = ({type = 'post', data = {}, success, error, requestDataType = '', async = true, enableAbortRequest = false}) => {
  sendAxios({
    url: '/file/deleteFiles',
    type: type,
    data: data,
    success: success,
    error: error,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  })
}



export default {
  checkPermission,
  queryCorpByParam,
  updateCorp,
  queryCurUserCorp,
  captchaCheck,
  checkName,
  registerProjectUser,
  modifyPassword,
  login,
  mobileLogin,
  sendSms,
  checkMobile,
  checkUserMobile,
  checkVerifyCodeCache,
  checkIfBindMobile,
  forgetPassword,
  getTemplateAndPlanCount,
  waterYieldInfo,
  waterYieldPeakInfo,
  waterQualityInfo,
  waterQualityStandardInfo,
  getTrendData,
  equAbnormityInfo,
  equMaintainPlanInfo,
  equMaintainRecordInfo,
  medicamentInfo,
  mudInfo,
  costInfo,
  waterYieldInfoCur,
  qualityRealTimeInfo,
  yieldRealTimeInfo,
  equRealTimeInfo,
  newestAbnormityRecordList,
  checkIfExist,
  temporaryPlanToday,
  planSpeedOfProgressTop,
  planSpeedOfProgressBody,
  planInfo,
  waterInletTrendChart,
  getOutWaterQualityTrendData,
  QRCodeLogin,

  saveCamera,
  deleteCamera,
  updateCameraById,
  queryCameraByParam,
  checkDuplicateCameraByParam,
  queryCameraById,

  saveCameraPreset,
  deleteCameraPreset,
  updateCameraPresetById,
  presetMove,
  presetEZVIZClear,
  getCameraPicforCameraId,
  queryCameraPresetByParam,
  queryCameraPresetById,
  delCameraPic,
  delMultiCameraPic,
  capturePic,
  gradualProgress,
  getCameraPosition,
  getKitToken,

  saveCameraAccount,
  deleteCameraAccount,
  updateCameraAccountById,
  queryCameraAccountByParam,
  deviceOnline,
  queryCameraAccountById,

  queryCameraPicTaskList,
  queryCameraAndPicList,
  queryCameraTaskByParam,
  saveCameraTask,
  deleteCameraTask,
  queryCameraAndPresetByParam,
  updateCameraTaskById,
  saveCameraTaskDetailBatch,
  updateCameraTaskDetail,
  queryCameraTaskById,
  queryPresetListByParam,
  userList,

  getEZVIZToken,
  getCameralist,
  getCameralistAndPreset,
  getAllCameraGroupByPosition,
  getCameraInfo,
  getEZVIZCameraInfo,
  ptzControl,
  consoleControl,
  presetEZVIZAdd,

  WxProjectInfo,
  WxGetOpenId,
  WxBindWechatMobile,
  WxRelateUser,

  getViewToken,
  getEquMstMonitorList,
  save3dPoint,
  cancleBind,
  saveBimDefCameraStatus,
  saveBimGisPoints,
  getBimInspectPlan,
  getBimInspectPointByPlanId,
  saveInspectPointBimInfo,
  saveRoamingPoint,
  getRoamingPointNameList,
  getRoamingPointListByRoamingPointId,
  getInspectPlanBimTree,
  deleteRoaming,
  getEleMenu,
  listEquElementRelation,
  showInfo,
  getCockpitSumData,
  getEquMonitor,
  getEquipValue,
  abnormityRecordListData,
  abnormityRecordListByDate,
  getMonitorDate,
  getAllMonitorCount,
  getMonitorOffLineCount,
  getMsgInfo,
  getCollectBimEquInfo, // 自己用
  getProjectMstBreakList,
  getProjectMstBreakListManual,
  getMaintainEquipOfAreaList,
  maintenanceRecordListData,
  maintenanceRecordPlanCount,
  breakdownTimeRank,
  datanewRankList,
  datanewEquBreakdown,
  datanewBreakdown,
  getEquBreakdown,
  getEquInfoByEquId,
  getAbnormityRate,
  getAnalyseDataforProject,
  getRunTimeAnalyse,
  bimGetAllEquByUnitId,
  bimGetEquWaringList,
  bimGetEquInfoById,
  bimGetEquMaintainInfo,
  bimEquTimeInfo,
  getYieldSomeInfo,
  getWarningLevelData,
  bimGetGisTitleList,
  bimGetGisTitlegetMonitorPointList,
  getFluidLevelChartData,
  getFluidChartData,
  bimGetAreaEquInfoByAreaId,
  getWarningTypeData,
  getMonitorListWeb,
  waterYieldInstantaddupValue,
  getModelAreaRunCount,
  getModelAreaBreakCount,
  bimGetElementAttr,
  bimGetPipelineConfigDatas,
  queryPlanListByEquipId,

  getMenuTree,
  getCityWeather,
  getRiverRealTimeWq,
  getRiverSum,
  warningList,
  updateProject,
  planInfoList,
  equlist,
  updateRunMode,
  getEquStatus,
  getEquSummary,
  getControlListforMonitorId,
  getControlInfo,
  controlExecute,
  executeStatus,
  checkPwd,
  equipmentDatainfo,
  getEquFuncTab,
  queryEquipByUnitListforMonitor,
  newequQueryData,
  getEquElectric,
  getRecent7daysAbRecord,
  queryMonthListData,
  queryRecordData,
  getMonitorList,
  arealist,
  modifyDefault,
  monitorSetDefault,
  cancelDefault,
  waterYieldTrendData,
  waterQualityTrendData,
  checkToken,
  maintenanceRepairData,
  repairList,
  fixRecordThisMonth,
  planCount,
  queryCountByUnit,
  rankList,
  maintenanceRecordList,
  abnormityRecordList,
  abnormityRecordChartData,
  maintenanceChartData,
  getProjectConfigObj,
  waterYieldMonitorPointCount,
  waterGaugeValue,
  warningCountByType,
  compareInAndOutChart,
  waterInletPeakChart,
  getMonitorPoints,
  waterAllTrendChart,
  getSearchWaterList,
  deleteSearchData,
  updateSearchData,
  waterManualMonitorPoints,
  checkExist,
  saveOrUpdateWaterResult,

  getDrawingList,
  getDrawingName,

  getWarningCount,
  checkMsgSum,
  provinceList,
  getWaterQuailtyMonitorList,
  countStatusByParam,
  countEquOnlineNum,
  saveProjectInfo,
  getEquipCycleTime,
  breakNum,
  groupTypeData,

  queryAvgWater,
  getWaterQualityForms,
  getWaterQualityData,
  getWaterQualityData1,
  projectDictList,
  getQualityChartData,
  getReductionData,
  getStandardData,
  getProjectUsers,
  getQueryData,
  getPointsValue,
  waterQualitySaveData,
  waterQualityDeleteData,
  searchProjectList,
  getGisEntireInfo,
  getGisDistrictInfo,

  getModuleInspectTime,
  obtainJumpItems,
  listAllDicItem,
  getDataPostsList,
  getDataPostsIconList,
  deletePostsIcon,
  getDataGroupList,
  getIndexConfigList,
  addOrUpdateDataGroup,
  removeIndexGroup,
  checkConfigName,
  changeOrderInList,
  changeOrderInGroup,
  getConfigDetail,
  configShowDataInList,
  moduleListData,
  saveDicConfig,
  deleteDicConfig,
  getShowDataInList,
  modifyInspectTime,
  obtainProcessUnits,
  obtainGroupAndItems,
  modifyDataConfigModule,
  zeroGetTableHead,
  zeroGetDataList,
  zeroRecordDetail,
  zeroDelete,
  zeroCheckDate,
  zeroUpdate,
  handoverGetTableHead,
  handoverGetDataList,
  handoverRecordDetail,
  handoverDelete,
  handoverCheckDate,
  handoverUpdate,
  onlineGetTableHead,
  onlineGetDataList,
  onlineDelete,
  onlineAddOrUpdate,
  onlineCheckDate,
  onlineRecordDetail,
  onlineGetUser,
  equTimeAddOrUpdate,
  equTimeCheckDate,
  equTimeDelete,
  equTimeGetDataList,
  equTimeGetTableHead,
  equTimeGetUser,
  equTimeRecordDetail,
  doDataGetTableHead,
  doDataGetDataList,
  doDataDelete,
  doDataAddOrUpdate,
  doDataCheckDate,
  doDataRecordDetail,
  getMonitorEquipmentList,
  getEquipmentLevelList,
  getEquRunCountStatus,
  runTimesRanking,
  countStatusForChart,

  obtainProjectMessageForSelect,
  obtainReportMessageForGrid,
  obtainReportTemplateForSelect,
  removeTemplate,
  reportFormOperateMapping,
  uploaderReportTemplate,

  addOrUpdatePost,
  removePost,
  getTeamList,
  addOrUpdateTeam,
  removeTeam,

  configReportList,
  paperSaveConfig,
  designUserList,

  getUserInfo,

  getProjectInfoById,
  getBusinessTypeList,

  insertOutsourcingUnit,
  deleteOutsourcingUnitById,
  updateOutsourcingUnit,
  selectOutsourcingUnit,
  selectOutsourcingUnitById,

  breakdownRecordList,

  monitorTreeGroupByType,

  getPlanTypeList,
  getDayPlan,
  getDayPlanByPlanTypes,
  rotaPlanDetail,
  rotaPlanDetailByPlanTypes,
  updatePlan,

  getWaterVolumeHeader,
  getWaterVolumeList,
  saveWaterVolumeData,
  removeWaterVolumeData,

  getProductionHead,
  getProductionList,
  removeProductionData,
  saveProductionData,
  getPlanProgressHead,
  getPlanProgressList,

  listProjectConfig,

  getMudPriceList,
  addMudPrice,
  updateMudPrice,
  deleteMudPrice,

  getMedicamentList,
  getMedicamentPriceList,
  deleteMedicamentPrice,
  addMedicamentPrice,
  updateMedicamentPrice,
  getInspectPlan,
  listAllInspectPointList,
  getUserInspectRecordList,
  getMstProcessAreaList,
  equlevellist,
  getUserInspectRecordDetail,
  historicTrack,
  loadInspectTaskList,
  loadInspectPlanTaskList,
  statisInspectData,
  loadUserListByTaskId,
  historicTrackByTaskId,

  depositoryList,
  addDepository,
  updateDepository,
  deleteDepository,
  materialList,
  addMaterialData,
  updateMaterialData,
  deleteMaterial,
  getMaterialDetail,
  materialDataLog,
  getInboundData,
  getInboundCode,
  getMaterialRestNum,
  saveInbound,
  editInbound,
  viewInboundRecord,
  delInbound,
  inventoryList,
  getOutboundData,
  getOutboundCode,
  editOutbound,
  saveOutbound,
  delOutbound,
  viewOutboundRecord,
  lossDataList,
  addLoss,
  updateLoss,
  deleteLoss,
  getLossrecord,
  getNowInventory,
  billList,

  getFileList,
  saveFiles,
  deleteFiles,
}



// WEBPACK FOOTER //
// ./src/assets/requestUrl.js